<template>
  <div class="breakdown" :class="{ 'no-border': !breakdownList }">
    <slot v-if="totalCount" name="total-count" />
    <slot v-if="accountList" name="account-list" />

    <ul v-if="breakdownList" class="breakdown-list">
      <slot name="divider" />
      <li>
        <ul>
          <slot name="content" />
        </ul>
      </li>
    </ul>
    <div v-if="searchListBottom">
      <slot name="search-list-bottom" />
    </div>
  </div>
</template>
<style type="scss" scoped></style>
<script>
import BaseContent from "@/components/BaseContent";
export default {
  name: "account",
  components: {},
  extends: BaseContent,
  props: {
    totalCount: { type: [Boolean], default: true },
    accountList: { type: [Boolean], default: false },
    breakdownList: { type: [Boolean], default: true },
    searchListBottom: { type: [Boolean], default: false },
  },
  data() {
    return {};
  },
};
</script>
